import { Component, Input } from '@angular/core';
// pake relative path biar lebih fleksibel
import { Poin } from '../../../../../../../../../@core/domain/poin.entity';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-poin-card',
  standalone: true,
  imports: [NgClass],
  templateUrl: './poin-card.component.html',
  styleUrl: './poin-card.component.scss'
})
export class PoinCardComponent {
  @Input({}) data: Poin = {
    ribbon_img: [],
    id:'',
    category: '',
    description: '',
    keyword : '',
    poin: '',
    title: ''
  };

}
